import { render, staticRenderFns } from "./insightsCard.vue?vue&type=template&id=65c14fb1&scoped=true&"
import script from "./insightsCard.vue?vue&type=script&lang=js&"
export * from "./insightsCard.vue?vue&type=script&lang=js&"
import style0 from "./insightsCard.vue?vue&type=style&index=0&id=65c14fb1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c14fb1",
  null
  
)

export default component.exports